import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './components/app/app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedService } from './services/shared.service';
import { AuthService } from './services/auth.service';
import { AuthInterceptor } from './interceptors';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { HttpClientModule } from  '@angular/common/http';
import { CountComponent } from './components/count/count.component';
import { FormsModule } from '@angular/forms';
import { NotificationComponent } from './components/notification/notification.component';
import { DateFacilityFlowComponent } from './components/date-facility-flow/date-facility-flow.component';

function initializeApp(authService: AuthService, sharedService: SharedService) {
  return async () => {
    authService.resolveLoginToken();
    await sharedService.initializeStore();
  };
}

@NgModule({
  providers: [
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AuthService, SharedService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  declarations: [
    AppComponent,
    CountComponent,
    NotificationComponent,
    DateFacilityFlowComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
    ],
  bootstrap: [AppComponent],
})
export class AppModule {}
